import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Divider, Text, Stack, Image, Box as Wrapper } from '@tonic-ui/react';
import styles from './cloud-video-content.module.css';
// video thumbnail background images
import videoThumbnailBgImg1 from '../../../assets/landing/img/video_thumbnail1.png';
import videoThumbnailBgImg2 from '../../../assets/landing/img/video_thumbnail2.png';
import ExternalLink from '../../external-link/external-link';

const FlexItem = ({ content }) => {
  return (
    <Flex flexDirection="column" alignItems="start" px="36px">
      <Wrapper width="100%">
        <ExternalLink href={content.videoUrl} showIcon={false}>
          <Image alt={content.altText} src={content.image} />
        </ExternalLink>
      </Wrapper>
      <Text fontSize="2xl" lineHeight="2xl" margin="31px 0 24px" color="black:primary">
        {content.title}
      </Text>
      <Divider width="80px" height="3px" bg="red:60" />
      <Wrapper
        marginTop="24px"
        width="160px"
        padding="13px 25px"
        border="0.5px solid #e52630"
        borderRadius="13px"
      >
        <ExternalLink
          href={content.videoUrl}
          showIcon={false}
          className={styles.video_link}
          alt={content.videoAltText}
        >
          <Text color="red:60" fontSize="lg" fontWeight="semibold" lineHeight="lg">
            {content.videoText}
          </Text>
        </ExternalLink>
      </Wrapper>
    </Flex>
  );
};

const CloudVideoContent = (): JSX.Element => {
  const { t } = useTranslation();
  const contents = [
    {
      id: '1',
      image: videoThumbnailBgImg1,
      title: t('publicLandingPage.cloudVideoContent.content1.title'),
      altText: t('publicLandingPage.cloudVideoContent.content1.altText'),
      videoText: t('publicLandingPage.cloudVideoContent.content1.videoText'),
      videoAltText: t('publicLandingPage.cloudVideoContent.content1.videoAltText'),
      videoUrl: t('publicLandingPage.cloudVideoContent.content1.videoUrl'),
    },
    {
      id: '2',
      image: videoThumbnailBgImg2,
      title: t('publicLandingPage.cloudVideoContent.content2.title'),
      altText: t('publicLandingPage.cloudVideoContent.content2.altText'),
      videoText: t('publicLandingPage.cloudVideoContent.content2.videoText'),
      videoAltText: t('publicLandingPage.cloudVideoContent.content2.videoAltText'),
      videoUrl: t('publicLandingPage.cloudVideoContent.content2.videoUrl'),
    },
  ];
  return (
    <Flex flexDirection="column" pb="100px">
      <Text
        mt="20px"
        mb="48px"
        fontWeight="light"
        fontSize="40px"
        lineHeight="64px"
        alignSelf="center"
        color="black:secondary"
      >
        {t('publicLandingPage.cloudVideoContent.heading')}
      </Text>
      <Stack spacing="4x" flexDirection="row">
        {contents.map((content) => (
          <FlexItem content={content} key={`video-${content.id}`} />
        ))}
      </Stack>
    </Flex>
  );
};

CloudVideoContent.displayName = 'CloudVideoContent';

export default CloudVideoContent;
